<div class="page-container">
    <div class="page-header">
        <div class="header-left">
            <div class="search-input">
                <hugeicons-icon [icon]="searchIcon" [size]="16" class="search-icon"></hugeicons-icon>
                <input type="text" placeholder="Search cases..." [value]="searchTerm" (input)="onSearchInput($event)">
            </div>
        </div>
    </div>

    @if (filteredCases.length > 0) {
        <div class="table-wrapper">
            <table class="cases-table">
                <thead>
                    <tr>
                        <th>Case Code</th>
                        <th>Client Name</th>
                        <th>Attorney</th>
                        <th>Hospital</th>
                        <th>Case Type</th>
                        <th>Lien Balance</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @for (case of filteredCases; track case.id) {
                    <tr (click)="viewCaseDetails(case)" class="table-row">
                        <td class="case-code">{{ case.caseCode || case.id }}</td>
                        <td>{{ case.clientName }}</td>
                        <td>{{ case.attorney }}</td>
                        <td>{{ case.hospital }}</td>
                        <td>{{ case.caseType }}</td>
                        <td class="lien-balance">{{ case.lienBalance | currency }}</td>
                        <td>
                            @if (getProgressStatus(case); as status) {
                                <span class="status-banner-inline" [ngClass]="status.variant">{{ status.label }}</span>
                            }
                        </td>
                        <td class="actions">
                            <button class="btn-icon" (click)="viewCaseDetails(case); $event.stopPropagation()"
                                [attr.aria-label]="'View case ' + (case.caseCode || case.id)">
                                <hugeicons-icon [icon]="viewIcon" [size]="18"></hugeicons-icon>
                            </button>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    } @else {
        <app-empty-state title="No Cases Found"
            description="There are no cases to display." [iconSize]="48">
        </app-empty-state>
    }
</div>
